import React from 'react';

export default ({ size = 16, color = '#000' }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
  >
    <path
      fill={color}
      stroke={color}
      d="M967.111 170.666h-56.889v-56.889c0-31.289-25.6-56.889-56.889-56.889h-796.444c-31.289 0-56.889 25.6-56.889 56.889v682.667c0 31.289 25.6 56.889 56.889 56.889h56.889v56.889c0 31.289 25.6 56.889 56.889 56.889h796.444c31.289 0 56.889-25.6 56.889-56.889v-682.667c0-31.289-25.6-56.889-56.889-56.889zM113.778 227.555v568.889h-56.788c-0.036-0.030-0.073-0.068-0.101-0.103v-682.462c0.030-0.036 0.068-0.073 0.101-0.101h796.24c0.036 0.030 0.073 0.068 0.103 0.103v56.786h-682.667c-31.289 0-56.889 25.6-56.889 56.889v0zM967.111 910.118c-0.030 0.036-0.068 0.073-0.103 0.103h-796.24c-0.036-0.030-0.073-0.068-0.101-0.103v-682.462c0.030-0.036 0.068-0.073 0.101-0.101h796.24c0.036 0.030 0.073 0.068 0.103 0.103v682.46z"
    />
    <path
      fill={color}
      stroke={color}
      d="M853.333 369.777c0 47.129-38.204 85.333-85.333 85.333s-85.333-38.204-85.333-85.333 38.204-85.333 85.333-85.333 85.333 38.204 85.333 85.333z"
    />
    <path
      fill={color}
      stroke={color}
      d="M910.222 853.332h-682.667v-113.778l199.111-341.333 227.556 284.444h56.889l199.111-170.667z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Gallery.js